import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { TabPanel, Tabs } from 'react-tabs'
import registerGraphic from '../../assets/images/khojgraphics/Change password page.png'
import axios, { PublicKey } from '../../API/axios'
import toast from 'react-hot-toast'
import { useNavigate } from "react-router-dom";
import logo2 from "../../assets/images/logo2.png";
import logo from "../../assets/images/logo.png";
import useLocalStorage from "use-local-storage";
import { Helmet } from 'react-helmet'


const ConfirmPassword = () => {
  const [showPass, setShowPass] = useState(false);
  const [showPass1, setShowPass1] = useState(false);
  const navigate = useNavigate();
  const [isDark, setIsDark] = useLocalStorage("isDark", false);

  const [showPass3, setShowPass3] = useState(false);
  const [showPass4, setShowPass4] = useState(false);

  const [isShowMobile, setShowMobile] = useState(false);
  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const UserUID = queryParams.get('UserUID');
  const Token = queryParams.get('Token');

  // Use UserUID and Token in your component logic
  console.log(UserUID, Token);


  const [newpassword, setnewPassword] = useState('')
  const [confirmpassword, setconfirmPassword] = useState('')
  const [displays, setDisplays] = useState(false)
  const [newPasswordError, setNewPasswordError] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');

  const validatePassword = (password) => {
    const regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
    return regex.test(password);
  };
  const handleNewPasswordChange = (e) => {
    const password = e.target.value;
    setnewPassword(password);
    if (!validatePassword(password)) {
      setNewPasswordError("Strong passwords must be 8+ characters and include uppercase letters, lowercase letters, numbers, and symbols.");
    } else {
      setNewPasswordError(""); // Clear error if valid
    }
    // Check for mismatch *immediately*
    if (password !== confirmpassword && confirmpassword !== "") {
      setConfirmPasswordError("Passwords do not match.");
    } else if (confirmpassword) { // Clear if they match, but only if confirm password has a value
      setConfirmPasswordError("");
    }
  };

  const handleConfirmPasswordChange = (e) => {
    const password = e.target.value;
    setconfirmPassword(password);

    if (!validatePassword(password)) {
      setConfirmPasswordError("Strong passwords must be 8+ characters and include uppercase letters, lowercase letters, numbers, and symbols.");
    } else {
      setConfirmPasswordError(""); // Clear error if valid
    }

    // Check for mismatch *immediately*
    if (password !== newpassword) {
      setConfirmPasswordError("Passwords do not match.");
    } else {
      setConfirmPasswordError(""); // Clear if they match
    }
  };


  const setPassword = async (e) => {
    console.log("==========clicked");

    e.preventDefault()
    if (!newpassword || !confirmpassword) {
      return toast.error("Please fill all fields")

    }
    const responseData1 = {
      "newPassword": newpassword,
      "confirmPassword": confirmpassword
    }
    console.log("responseData1", responseData1);

    try {

      setDisplays(true)
      {
        const res = await axios.post(`/Auth/SetNewPassword?UserUID=${UserUID}&Token=${Token}`, responseData1,
          {
            headers: {
              PublicKey,
            },
          }
        );
        console.log('ghgh', res);
        navigate(`/login`);
        toast.success(res.data.message)
      }

    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.error(error.response.data.message)
      } else {
        toast.error(error.response.data.message)
      }
    } finally {
      setDisplays(false)
    }
  }

  return (
    <>
      <Helmet>
        <title>Set New Password | Jobkikhoj</title>
        <meta name="description" content=" " />
        <meta name="keywords" content=" " />
        <meta property="og:title" content=" Set New Password | Jobkikhoj" />
        <meta property="og:description" content="" />
        <meta property="og:url" content="https://jobkikhoj.com" />
      </Helmet>

      <header>
        <div className="main-logo">
          <div className="header-ct-left d-flex justify-content-center mt-3 setnewpassword">
            {isDark ? (
              <div id="logo" className="logo">
                <Link to="/Home">
                  <img
                    className="site-logo"
                    id="trans-logo"
                    src={logo2}
                    alt="logo"
                  />
                </Link>
              </div>
            ) : (
              <div id="logo" className="logo">
                <Link to="/Home">
                  <img
                    className="site-logo"
                    id="trans-logo"
                    src={logo}
                    alt="logo"
                  />
                </Link>
              </div>
            )}
          </div>
        </div>
      </header>

      <section className="account-section p-3">
        <div className="container">
          <div className="row">
            <div className="col-md-6 registerGraphics">
              <img src={registerGraphic} width={'100%'} />
            </div>
            <div className="col-md-6">
              <Tabs className="wd-form-login tf-tab">
                <h4 className="mt-3">Set New Password</h4>
                <div className="content-tab">
                  <TabPanel className="inner animation-tab">
                    <form action="/">
                      <div className="ip">
                        <label>New Password</label>
                        <div className="inputs-group auth-pass-inputgroup">
                          <input
                            type={showPass ? "text" : "password"}
                            className="input-form password-input"
                            placeholder="New Password"
                            id="password-input"
                            // onChange={(e) => setnewPassword(e.target.value)}
                            onChange={handleNewPasswordChange}
                            //value={newpassword}
                          //invalid={displays && newpassword === ''}
                          />
                          <Link
                            className={`password-addon ${showPass ? "icon-eye" : "icon-eye-off"
                              }`}
                            id="password-addon"
                            onClick={(e) => {
                              e.preventDefault()
                              setShowPass(!showPass)
                            }}
                          />
                          {/* {displays && !newpassword ? <span className='error_msg_lbl text-red'>Enter New Password </span> : null} */}

                        </div>
                        <div> {newPasswordError && <span className='error_msg_lbl text-red'>{newPasswordError}</span>}</div>
                      </div>
                      <div className="ip">
                        <label>Confirm Password</label>
                        <div className="inputs-group auth-pass-inputgroup">
                          <input
                            type={showPass1 ? "text" : "password"}
                            className="input-form password-input"
                            placeholder="Confirm Password"
                            id="password-input"
                            onChange={handleConfirmPasswordChange}
                            //onChange={(e) => setconfirmPassword(e.target.value)}
                            //value={confirmpassword}
                          //invalid={displays && confirmpassword === ''}
                          />
                          <Link
                            className={`password-addon ${showPass1 ? "icon-eye" : "icon-eye-off"
                              }`}
                            id="password-addon"
                            onClick={(e) => {
                              e.preventDefault()
                              setShowPass1(!showPass1)
                            }}
                          />
                          {/* {displays && !confirmpassword ? <span className='error_msg_lbl text-red'>Enter Confirm Password </span> : null} */}
                        </div>
                      </div>
                      <button onClick={(e) => { setPassword(e) }}>Reset</button>
                    </form>
                  </TabPanel>
                </div>
              </Tabs>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}

export default ConfirmPassword